import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Program, Contract, Cedant, ContractStage } from '../shared.types';

@Injectable({
  providedIn: 'root'
})
export class ContractSelectorService {

  // TODO: URLs and API
  constructor(private httpClient: HttpClient) { }

  private cedantsLocation:   string = '/client/cedants';
  private programsLocation:  string = '/client/cedant/programs';

  private cedantsUrl: string = '/assets/_mocks/cedants.json';
  private contractsLocation: string = '/assets/_mocks/cedant/program/contracts.json';


  getContracts(): Observable<Contract[]> {
    return this.httpClient
      .get<Contract[]>(this.contractsLocation);
  }

  // TODO (NR): Create Type Cedants Observable
  getAllCedants(): Observable<any>  {
    return this.httpClient
      .get<any>(this.cedantsUrl);
  }
}
